import React, { useState } from 'react';
import '../styles/CommonComponentStyles.scss';
import { useNavigate } from 'react-router-dom';
import ImprintEn from './core_content/ImprintEn.js'; // English version
import ImprintDe from './core_content/ImprintDe.js'; // German version
import { Helmet } from 'react-helmet-async';

const Imprint = () => {
    const navigate = useNavigate();
    const [isEnglish, setIsEnglish] = useState(true); // State to toggle between languages

    // Routes one level back to /account/help
    const handleBackRequest = () => {
        navigate("/");
    };

    const toggleLanguage = () => {
        setIsEnglish(!isEnglish); // Toggle the language state
    };

    return (
        <div className="common-styles">
            <Helmet>
                <title>generatebg - Imprint</title>
                <meta name="description" content="Read generatebg imprint here." />
                <link rel="canonical" href={`${process.env.REACT_APP_CLIENT_URL}/imprint`} />
            </Helmet>
            <button className="generic-account-button--center" onClick={handleBackRequest}>Go Back Home</button>
            <button className="generic-account-button--center" onClick={toggleLanguage}>
                {isEnglish ? 'Switch to German' : 'Auf Englisch wechseln'}
            </button>
            {isEnglish ? <ImprintEn /> : <ImprintDe />}
        </div>
    );
};

export default Imprint;
